import { getMergedAuthFields } from '@shared/utils';
import FORM_AUTH_TYPES from '@/lib/connections/formAuthTypes.js';

/**
 * How a person connects an app from the web: the first sign-in method that takes typed values
 * (API key, username and password, custom fields, or nothing at all) and the fields it asks for.
 * Apps that only sign in with OAuth have no method here: they connect from a conversation.
 */
const resolveConnectMethod = (app) => {
  const authentication = Array.isArray(app?.authentication) ? app.authentication : [];
  const auth = authentication.find((candidate) => candidate?.hidden !== true && FORM_AUTH_TYPES.includes(candidate?.type)) || null;

  if (!auth) {
    return null;
  }

  return { auth, fields: getMergedAuthFields({ authType: auth.type, auth }) };
};

export default resolveConnectMethod;
